<template>
    <div class="add-edit-store">
        <v-form @submit.prevent="submitStoreDetails" v-model="storeDetailsForm" ref="storeDetailsForm">
            <v-row>
                <v-col cols="8">
                    <h1 class="text-left ml-8 my-2">
                        <span v-if="!is_editing">Add</span>
                        <span v-else>Edit</span> Store
                    </h1>
                    <p v-if="!is_editing" class="text-left ml-8">Add a new Store to your Inventory.</p>
                    <p v-else class="text-left ml-8">Edit Store details in your Inventory.</p>
                    <h5 class="text-left ml-8 font-weight-regular">* indicates required field</h5>

                </v-col>
                <v-col cols="4" class="text-right">
                    <v-btn
                        v-if="is_editing && currentUser.privileges.canDeleteStores"
                        color="red"
                        class="my-2 mr-8"
                        dense
                        small
                        @click="showDeleteDialog"
                        rounded
                        outlined
                    >Delete</v-btn>
                </v-col>
            </v-row>

            <v-row class="mx-4">
                <v-col cols="12">
                    <v-card>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <p class="text-left mx-2 mb-1">Store Name<span class="required"></span></p>
                                <v-text-field
                                    v-model="store.store_name"
                                    outlined
                                    :rules="[rules.required, rules.store_name]"
                                    dense
                                    placeholder="eg. Stationary"
                                    class="rounded-input"
                                    hide-details="auto"
                                    maxlength="55"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <p class="text-left mx-2 mb-1">Code
                                    <span class="required"></span>
                                    
                                </p>
                                <v-text-field
                                    v-model="store.code"
                                    outlined
                                    :rules="[rules.required, rules.code]"
                                    dense
                                    placeholder="eg. STN"
                                    class="rounded-input"
                                    maxlength="4"
                                    hide-details="auto"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <p class="text-left mx-2 mb-1">Invoice Prefix 
                                    <span class="required"></span>
                                </p>
                                <v-text-field
                                    v-model="store.invoice_prefix"
                                    outlined
                                    :rules="[rules.required, rules.invoice_prefix]"
                                    dense
                                    placeholder="eg. INST"
                                    class="rounded-input"
                                    hide-details="auto"
                                    maxlength="4"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <p class="text-left mx-2 mb-1">
                                Store Type
                                <span class="required"></span>
                                </p>
                                <v-autocomplete
                                    v-model="store.store_type"
                                    :items="store_types"
                                    item-text="type_name"
                                    item-value="id"
                                    :rules="[rules.required_type]"
                                    class="rounded-input"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    return-object
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4">
                                <p class="text-left mx-2 mb-1">
                                Store Category
                                <span class="required"></span>
                                </p>
                                <v-autocomplete
                                    v-model="store.store_category"
                                    :items="store_categories"
                                    item-text="category_name"
                                    item-value="id"
                                    :rules="[rules.required_category]"
                                    class="rounded-input"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    return-object
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <div class="text-right mx-4 my-4">
                        <v-btn
                            class="mr-4"
                            color="red"
                            :to="{ name: 'InventoryDashboard' }"
                            rounded
                            outlined
                        >Cancel</v-btn>

                        <v-btn color="primary" type="submit" :disabled="!storeDetailsForm" rounded>Submit</v-btn>
                        </div>
                    </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
        <DeleteConfirmationDialog
            title="Are you sure you want to delete this Store?"
            :visible="showDeleteConfirmation"
            @deleteObject="deleteObjectConfirmation"
        />
        <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";

export default {
    name: 'AddEditStore',
    components:{
        DeleteConfirmationDialog,
    },
    data(){
        return {
            storeDetailsForm : true,
            is_editing: false,
            rules: {
                required: (v) => !!v || "This field is required",
                store_name: (v) => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
                code: (v) => /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid",
                invoice_prefix: (v) => !v || /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid",
                required_category: (v) => !!v.id || "Select a category",
                required_type: (v) => !!v.id || "Select a type",
            },
            store_types : [],
            store_categories : [],
            store: {
                store_name : null,
                code: null,
                invoice_prefix : null,
                store_type: {
                    id: null,
                    code: null,
                    type_name: null,
                    institution: null,
                },
                store_category: {
                    id: null,
                    code: null,
                    cateogory_name: null,
                    institution: null,
                },
                institution: null,
                store_items: [],

            },
            showDeleteConfirmation: false,
            snackbar: {
                visible: false,
                message: "",
                color: "dark",
            },

        };
    },
    computed:{
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods: {
        ...mapActions(["setLoading"]),
        async getStoreDetails(){
            var url = endpoints.stores + this.$route.params.store_id + "/";
            this.store = await api.call(this.essentials, url);
        },

        async getAllStoreTypes(){
            this.store_types = await api.call(this.essentials, endpoints.storeType);
        },

        async getAllStoreCategories(){
            this.store_categories = await api.call(this.essentials, endpoints.storeCategory);
        },

        async submitStoreDetails(){
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: endpoints.stores,
                responseVar: response,
                method: api.Methods.POST,
                body: {
                    is_editing: this.is_editing,
                    edit_id: this.is_editing? this.store.id : null,
                    code: this.store.code,
                    store_name: this.store.store_name,
                    invoice_prefix: this.store.invoice_prefix,
                    type_id: this.store.store_type.id,
                    category_id: this.store.store_category.id,
                }
            });
            if(response){
                this.$router.push({ name: 'StoreDetails', params: { store_id: response.id } });
            }
        },
        async showDeleteDialog() {
            this.showDeleteConfirmation = true;
        },

        async deleteObjectConfirmation(confirm) {
            this.showDeleteConfirmation = false;
            var url = endpoints.stores + this.store.id + "/";
            if (confirm) {
                var response;
                response = await api.handleApi({
                    apiEssentials: this.essentials,
                    url: url,
                    method: api.Methods.DELETE,
                    responseVar: response,
                });
                if (response) {
                    this.$router.push({ name: "InventoryDashboard" });
                }
            }
        },

        // handles api errors
        handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                if (err.response.status == 409) {
                this.snackbar.message = err.response.data.message;
                this.snackbar.color = "error";
                this.snackbar.visible = true;
                }
            } else {
                this.snackbar.message = "Unable to process request";
                this.snackbar.color = "error";
                this.snackbar.visible = true;
            }
        },
    },
    created(){
        if(this.$route.params.store_id){
            this.is_editing = true,
            this.getStoreDetails();
        }
        this.getAllStoreTypes();
        this.getAllStoreCategories();
    }
    
}
</script>

<style scoped>
.rounded-input {
  border-radius: 12px !important;
}
span.required::after {
  content: "*";
  font-size: 18px;
  color: red;
}
</style>